// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Bn-z","tupacHeader":"Cn-z","tupacHeader2":"Dn-z","tupacMenu":"En-z","tupacMenu2":"Fn-z","tupacMain":"Gn-z","tupacMain2":"Hn-z"};